/**
 * Created by d.penning on 04.10.2017.
 */
import * as actions from '../actions/actionTypes'
import { getActiveChannelId } from './gui';
import { ITimingsState, IState, ITimingsChannel } from '../store/state';
import { getEnvironment } from './bookmakerOptions';
import { PHASE_BETSTOP, PHASE_RALLY, PHASE_POST_MATCH } from '../api/phases';
import { ITimingsFeed, ITimingsTimestamps } from '../types/ITimings';

export const initialTimingsState: ITimingsState = {
	clientRequestTimestampMs: 0,
    clientResponseTimestampMs: 0,
    serverHeaderTimestampMs: 0,
	serverContentTimestampMs: 0,
	serverCalculationTimeMs: 0,
	wasCacheHit: false,
	age: 0,
	expiresMs: 0,
	channels: [],
	prevChannels: [],
}

// this function is used to handle the data of the related actions and creates a new store. This function has to be exported to combine it with other reducers in rootReducer.ts
const timings = (state: ITimingsState = initialTimingsState, action: any) : ITimingsState => {
	switch (action.type) {
		case actions.FETCH_TIMINGS_SUCCEEDED:
			const timingsJson : ITimingsFeed = action.data.timings
			const timestamps : ITimingsTimestamps = action.data.timestamps
			return {
				...state,
				clientRequestTimestampMs: timestamps.clientRequestTimestampMs,
				clientResponseTimestampMs: timestamps.clientResponseTimestampMs,
				serverHeaderTimestampMs: timestamps.serverHeaderTimestampMs,
				serverContentTimestampMs: timestamps.serverContentTimestampMs,
				serverCalculationTimeMs: timestamps.serverCalculationTimeMs,
				wasCacheHit: timestamps.wasCacheHit,
				age: timestamps.serverAgeMS,
				expiresMs: timestamps.expiresMs,
				channels: state.channels.length == 0
					? timingsJson.channels 
					: state.channels.map((prevChannel: ITimingsChannel) => {
						let newChannel = action.data.timings.channels
							.filter((newChannel: ITimingsChannel) => newChannel.id === prevChannel.id)
							.pop();
						return Object.assign({}, prevChannel, newChannel);
					}),
				prevChannels: state.channels
			};
		case actions.PROPAGATE_COUNTDOWN_BY_CHANNEL:
			let newState: ITimingsState = Object.assign({}, state);
			newState.channels = newState.channels.map((channel: any) => {
				let newChannel = Object.assign({}, channel);
				if(newChannel.id === action.data.channelId) {
					// FIXME This is wrong on an architectural level.
					newChannel.countdown = action.data.countdown;
					newChannel.phase_id = action.data.phaseId;
				} 
				return newChannel;
			});
			return newState;
		default:
			return state;
	}
};

export const getMatchCountdownByChannelId = (state: IState, channelId: number) => {
	const countdown = getTimings(state)
	.filter((channel: ITimingsChannel) => channel.id === channelId)
	.pop()
	.countdown
	return countdown;
};

export const getMatchIdsByChannelIds = ( state: IState, channelIds: number[] ) => {
	return getTimings( state )
		.filter( timing => channelIds.includes(timing.id) )
		.map( (timing: any) => timing.match )
}

// returns the number of matches listed in the store
export const getNumberOfMatchesInStore = (state:IState) => {
		return Object.keys(state.matches).length;
}

export const getChannelIdByMatchId = ( state: IState, matchId: number ) => {
	return getTimings( state )
		.find(timing => matchId === timing.match_id ).id
}

export const getLastClientRequestTimestampMs = ( state: IState ) : number => state.timings.clientRequestTimestampMs;
export const getLastClientResponseTimestampMs = ( state: IState ) : number => state.timings.clientResponseTimestampMs;
export const getLastServerHeaderTimestampMs = ( state: IState ) : number => state.timings.serverHeaderTimestampMs;
export const getLastServerContentTimestampMs = ( state: IState ) : number => state.timings.serverContentTimestampMs;
export const getLastServerCalculationTimeMs = ( state: IState ) : number => state.timings.serverCalculationTimeMs;
export const getLastServerAgeMS = ( state: IState ) : number => state.timings.age*1000;
export const wasCacheHit = ( state: IState ) : boolean => state.timings.wasCacheHit
export const getExpiresMs = ( state: IState ) : number => state.timings.expiresMs

export const getNearestPhaseChangeTimeMs = (state:IState) : number => {
	const timings = getTimings(state);
	let nextPhaseChangeTime = timings[0].active_phase_end_datetime;
    for (let channelTiming of timings) {
        if( channelTiming.active_phase_end_datetime < nextPhaseChangeTime ) {
            nextPhaseChangeTime = channelTiming.active_phase_end_datetime;
        }
	}
	
	return nextPhaseChangeTime*1000;
}

export const getLatencyMs = (state:IState) : number => {
	let lastRequestLength = 0;
	if(getLastClientRequestTimestampMs(state)) {
		lastRequestLength = getLastClientResponseTimestampMs(state)-getLastClientRequestTimestampMs(state);
		if( !wasCacheHit(state) ) {
			lastRequestLength -= getLastServerCalculationTimeMs(state);
		}
	}
	return lastRequestLength/2; // approximation, obviously
}

export const calculateCurrentServerTimeMs = (state:IState) : number => {
	const latency = getLatencyMs(state);
	const correctedServerTime = getLastServerContentTimestampMs(state)-getLastServerAgeMS(state)-latency;
	const timePassed = Date.now()-getLastClientResponseTimestampMs(state);
	return correctedServerTime+timePassed;
}


export const getCurrentDelta = ( state: IState ) : number => Math.floor((state.timings.clientResponseTimestampMs-state.timings.serverHeaderTimestampMs)/1000);

export const getNextBetstopByChannelId = ( state: IState, channelId: number ) => {
	return getChannelByChannelId( state, channelId ).betstop_datetime
}

export const getAllActivePhaseEndDatetime = ( state: IState ) =>
	getTimings( state ).map( ( channel: any ) => channel.active_phase_end_datetime )

const calcDelayToNextPhaseChange = (dateTimePhaseChange: number, datetimeServer: number) => {
	const delay: number = dateTimePhaseChange - datetimeServer
	return delay > 1 ? delay : 1
}

export const getDelayInSecondsToNextPhaseChange = ( state: IState ) =>{
	return calcDelayToNextPhaseChange( getPhaseEndDateTimeOfNextPhaseChange( state ), Math.floor((state.timings.serverHeaderTimestampMs)/1000));
}

export const getPhaseEndDateTimeOfNextPhaseChange = ( state: IState ) =>{
	return Math.min(...getAllActivePhaseEndDatetime( state ))
}

export const getDateOfNextPhaseChange = ( state: IState ) =>
	new Date(getPhaseEndDateTimeOfNextPhaseChange(state) * 1000).toString()

export const getCahnnelIdOfSmallestPhaseChangeDelay = ( state: IState ) =>
	getTimings( state ).find( ( channel: any ) => {
		let channelPhaseChangeTimestamp = channel.active_phase_end_datetime

		if(channelPhaseChangeTimestamp === null) {
			channelPhaseChangeTimestamp = 0
		}

		return channelPhaseChangeTimestamp === getPhaseEndDateTimeOfNextPhaseChange( state )
	}).id

export const getChannelByMatchId = (state: IState, matchId: number) => {
	return getTimings( state ).find( ( channel: any ) => channel.match_id === matchId )
}

export const getPhaseIdByMatchId = (state: IState, matchId: number) => {
	return getChannelByMatchId(state, matchId).phase_id
}

export const getPhaseIdByChannelId = (state: IState, channelId: number) => {
	return getChannelByChannelId(state, channelId).phase_id
}

// this are a helper functions to handle specific data requests on timings data
export const getTimings = (state: IState)  : ITimingsChannel[] => state.timings.channels;

export const getPrevTimings = (state: IState)  : ITimingsChannel[] => state.timings.prevChannels;

export const getChannelIdsWithNewPhases = (state:IState) : number[] => {
	const changeChannelIds : number[] = [];

	const newTimings = getTimings(state);
	const oldTimings = getPrevTimings(state);

    for (let channelTiming of newTimings) {
        const oldTiming = oldTimings.find((timing: any) => timing.id === channelTiming.id);
        if (!oldTiming || channelTiming.phase_id !== oldTiming.phase_id) {
			changeChannelIds.push( channelTiming.id );
		}
	}
	return changeChannelIds;
}

/**
 *  Retrieves the match ids of channels where a phase change occured with the last timings update
 * @param state 
 */
export const getMatchIdsForChannelsWithNewPhases = (state:IState) : number[] => {
	const changeChannelMatchIds : number[] = [];

	const newTimings = getTimings(state);
	const oldTimings = getPrevTimings(state);

    for (let channelTiming of newTimings) {
        const oldTiming = oldTimings.find((timing: ITimingsChannel) => timing.id === channelTiming.id);
        if (!oldTiming || channelTiming.phase_id !== oldTiming.phase_id) {
			const matchId = channelTiming.match_id;
			changeChannelMatchIds.push( matchId );
		}
	}
	return changeChannelMatchIds;
}


// returns the number of channels by getting the number of objects in timings
export const getNumberOfChannels = (state: IState) => state.timings.channels.length

export const getMatchIdByChannelId = (state: IState, channelId: number) => {
		return getChannelByChannelId(state, channelId) ? getChannelByChannelId(state, channelId).match_id : null;
}

export const getMatchIds = (state: IState) => {
	return getTimings(state) ? getTimings(state).map((match: any) => match.match_id) : [];
};

export const getChannelByChannelId = (state: IState, channelId: number) => {
	return  getTimings(state) ? getTimings(state).find((channel:any) => channel.id === channelId) : null;
};

export const getActiveMatchId = (state: IState) : number=> {
    return getMatchIdByChannelId(state, getActiveChannelId(state));
}

export const getActiveTimingsChannel = (state: IState) : ITimingsChannel => {
    return getChannelByChannelId(state, getActiveChannelId(state));
}

export const getUrlTarget = (state: IState) : string => getEnvironment(state)=='Production'?'vti':'ls';

// we want closed markets in phases betstop, rally and post_match in BWG
export const shouldOddsBeOpen = (phaseId: number) : boolean => !(phaseId === PHASE_BETSTOP || phaseId === PHASE_RALLY || phaseId === PHASE_POST_MATCH);

export default timings;
